
    import './styles.scoped.css';
    export default {
  "selectable-item": "awsui_selectable-item_15o6u_mphl6_93",
  "pad-bottom": "awsui_pad-bottom_15o6u_mphl6_117",
  "has-background": "awsui_has-background_15o6u_mphl6_126",
  "highlighted": "awsui_highlighted_15o6u_mphl6_129",
  "selected": "awsui_selected_15o6u_mphl6_129",
  "disabled": "awsui_disabled_15o6u_mphl6_147",
  "next-item-selected": "awsui_next-item-selected_15o6u_mphl6_157",
  "is-keyboard": "awsui_is-keyboard_15o6u_mphl6_169",
  "parent": "awsui_parent_15o6u_mphl6_173",
  "interactiveGroups": "awsui_interactiveGroups_15o6u_mphl6_177",
  "child": "awsui_child_15o6u_mphl6_195",
  "virtual": "awsui_virtual_15o6u_mphl6_210",
  "measure-strut": "awsui_measure-strut_15o6u_mphl6_221",
  "measure-strut-first": "awsui_measure-strut-first_15o6u_mphl6_230",
  "screenreader-content": "awsui_screenreader-content_15o6u_mphl6_234",
  "option-content": "awsui_option-content_15o6u_mphl6_240"
};
  